module.exports = __webpack_public_path__ + "6866dfe0b5533b26b4c35ec7c4756aaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-index-img6.jpg
// module id = 230
// module chunks = 3